import { Box, Link as MuiLink, Stack } from '@mui/material'
import { Link } from 'react-router-dom'

import logoWhite from '~/assets/images/corp/logo-white.svg'
import { EMarketingClientPath } from '~/models/api'
import rem from '~/utils/ui'

function Logo() {
  return (
    <MuiLink
      component={Link}
      to={EMarketingClientPath.home}
      sx={{ textDecoration: 'none', mr: 2 }}
    >
      <Stack direction="row" alignItems="center">
        <Box
          component="img"
          alt="logo"
          src={logoWhite}
          sx={{
            width: rem(150),
          }}
        />
      </Stack>
    </MuiLink>
  )
}

export default Logo
